import FasterHttpClient from 'Faster/network/FasterHttpClient';
import GeoLocation from 'Faster/model/GeoLocation';
import GetGeoLocationRequest from 'Faster/request/GetGeoLocationRequest';

class GeoService {
  private fasterClient: FasterHttpClient;

  public constructor(fasterClient: FasterHttpClient) {
    this.fasterClient = fasterClient;
  }

  public async getLocation(): Promise<GeoLocation> {
    const request = new GetGeoLocationRequest();

    const response = await this.fasterClient.executeWithoutRetry(request);
    const responseBody = await response.json();

    switch (response.status) {
      case 200: {
        return responseBody;
      }
      case 404:
        // eslint-disable-next-line no-case-declarations
        let errorMessage = responseBody?.description || 'Geolocation not found';
        throw new Error(errorMessage);
      default:
        errorMessage = responseBody?.description || 'Unknown error, failed to fetch geolocation';
        throw new Error(errorMessage);
    }
  }
}

export default GeoService;
